import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import { styled,createTheme, ThemeProvider } from '@mui/material/styles';
import MainContent from './MainContent';

import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Footer from '../dashboard/About';
import { mainListItems, secondaryListItems } from '../listItems';
import Link from '@mui/material/Link';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Profile from '../profile'
import StructuredData from '../StructuredData';
import "../CSS/styles.css";
import { Helmet } from 'react-helmet';
export default function Blog() {
  const [mode, setMode] = React.useState('light');
  const [showCustomTheme, setShowCustomTheme] = React.useState(true);
 // const blogTheme = createTheme(getBlogTheme(mode));
  const defaultTheme = createTheme({ palette: { mode } });
  // This code only runs on the client side, to determine the system color preference
  React.useEffect(() => {
    // Check if there is a preferred mode in localStorage
    const savedMode = localStorage.getItem('themeMode');
    if (savedMode) {
      setMode(savedMode);
    } else {
      // If no preference is found, it uses system preference
      const systemPrefersDark = window.matchMedia(
        '(prefers-color-scheme: dark)',
      ).matches;
      setMode(systemPrefersDark ? 'dark' : 'light');
    }
  }, []);
  
const drawerWidth = 240;

  const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
  })(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  }));

  
const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        display:'none',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
    },
  }),
);

  const [open, setOpen] = React.useState(true);
  const toggleDrawer = () => {
    setOpen(!open);
  };
  
const theme = createTheme({
  palette: {
    mode: 'light',  // or 'dark'
  },
});
  const toggleColorMode = () => {
    const newMode = mode === 'dark' ? 'light' : 'dark';
    setMode(newMode);
    localStorage.setItem('themeMode', newMode); // Save the selected mode to localStorage
  };

  const toggleCustomTheme = () => {
    setShowCustomTheme((prev) => !prev);
  };

  return (
    <>
    <StructuredData />
    <Container
    maxWidth="xl"
    component="main"
    sx={{ display: 'flex', flexDirection: 'column', my: 16, gap: 4 }}
  >
    <Helmet>
       <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta property="og:type" content="website" />
    <meta property="og:site_name" content="SVR Taxi Service | Call to book 9965821750" />
    <meta charset="UTF-8" />
    <meta name="description" content="Reliable, taxi, service, in Salem, and, across India. Available 24/7 with professional drivers and affordable pricing. Book now for a comfortable journey."/>
    <meta name="keywords" content="taxi ,service, Salem, India, airport, transfers, intercity, travel, taxi ,booking,svr taxi,Affordable, taxi ,service ,from ,Salem, to ,Chennai,Best, outstation, cab ,service, from ,Salem ,to ,Kodaikanal,Taxi ,service ,for ,day, trips, in ,and, around, Salem,One-way ,taxi ,service ,from ,Salem ,to ,Bangalore,Book ,a, cab, for ,Salem to ,Tiruchirappalli ,trip,Salem to ,Yercaud ,cab ,service for ,family ,trips,Reliable ,24-hour, taxi, service in Salem,Taxi booking, for airport transfers, in Salem,Safe, taxi, service ,for solo ,women, travelers ,in Salem,Outstation, cab, services ,from Salem ,for business ,trips,Affordable car ,rental ,for Salem, sightseeing,Affordable ,Salem to ,Ooty, weekend, tour ,packages,Salem to ,Munnar, taxi, service with sightseeing packages,Pilgrimage, taxi service from, Salem to ,Samayapuram, Temple,
    Budget ,taxi, packages, from Salem to ,Hogenakkal, Falls,Cab service for Salem to ,Kodaikanal, honeymoon, package,Luxury, taxi service, for ,corporate ,trips, from Salem to ,Chennai,Round-trip, taxi ,service ,from Salem to, Mysore,Car, rental, with, driver, for ,outstation trips, in ,Tamil Nadu,Customized, tour packages, with taxi service in Tamil Nadu,
    Cheap, cab ,service for ,outstation trips, from Salem, best, taxi service in salem , best , taxi , service , Best taxi service in salem , Best Cab service in salem , Call and Book Ride 9965821750"/>
  
    <meta name="author" content="SVR Taxi" />
   

{/* {    <link rel="icon" href="%PUBLIC_URL%/favicon.ico" type="image/x-icon" /> } */}

    <meta property="og:title" content="SVR- Taxi Service in Salem & Across India" />
    <meta property="og:description" content="Providing safe, reliable, and affordable taxi services in Salem and across India. Book now for a hassle-free experience."/>

    <meta property="og:url" content="https://yourwebsite.com"/>
 
    <link rel="stylesheet" href="%PUBLIC_URL%/styles.css"/>
    <link rel="preconnect" href="https://fonts.googleapis.com"/>
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
    <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap" rel="stylesheet" />

      
        
        </Helmet>  
        <MainContent />
          
          </Container>
          </>
  );
}
